import DescriptionIcon from '@mui/icons-material/Description';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';

import React from 'react';

import { AiVoice } from '_lib/api/apiTypes.shim';
import { Stack } from '_lib/components/Stack/Stack';
import { IconTypography } from '_lib/featureComponents/IconTypography/IconTypography';

export const VoiceSelectionItem = ({ voice }: { voice: AiVoice }) => {
  return (
    <Stack useFlexGap spacing={0}>
      <IconTypography
        startIcon={voice.gender === 'male' ? <MaleIcon /> : <FemaleIcon />}
        text={`${voice.name} (${voice.providerVoice.provider})`}
      />
      <IconTypography
        startIcon={<DescriptionIcon />}
        text={voice.description || 'No description available'}
        variant='subtitle2'
      />
    </Stack>
  );
};
